<template>
    <ion-header>
        <ion-toolbar>
            <ion-buttons slot="end" v-show="auth">
                <ion-menu-button menu="settings">
                    <ion-icon :icon="settings" />
                </ion-menu-button>
            </ion-buttons>
            <ion-buttons slot="start" v-show="auth">
                <ion-menu-button menu="navigation">
                    <ion-icon :icon="menu" />
                </ion-menu-button>
            </ion-buttons>
            <ion-title>{{ title }}</ion-title>
        </ion-toolbar>
    </ion-header>
</template>

<script>

import { IonHeader, IonToolbar, IonTitle, IonButtons, IonMenuButton, IonIcon } from '@ionic/vue';
import { settings, menu } from 'ionicons/icons';
import Storage  from '@/services/Storage';

export default {
    name: "StandardHeader",
    props: ['title'],
    components: {
        IonHeader, IonToolbar, IonTitle, IonButtons, IonMenuButton, IonIcon
    },
    mounted() {
        this.storage.get('user').then(user => {
            if (user) {
              this.auth = user.id > 0;
            }
        });
    },
    data() {
        return {
            auth: false
        }
    },
    setup() {
        const storage = new Storage();
        return {
            settings, menu, storage
        }
    }
}
</script>

<style scoped>
    ion-title {
        text-transform: uppercase;
    }
</style>
